import { StyledButton } from './buttonWithGradientHover.styles';
import { IButtonProps } from '../Button/interfaces';

export const ButtonWithGradientHover = ({
  children,
  onClick,
  disabled,
  fillButton,
  fit,
  as,
  ...props
}: IButtonProps) => {
  return (
    <StyledButton
      disabled={disabled}
      fillButton={fillButton}
      fit={fit}
      onClick={onClick}
      as={as}
      {...props}
    >
      {children}
    </StyledButton>
  );
};
